import * as React from 'react';
import { Toggle } from './Toggle';

export interface ToggleSettingProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  title: string;
  description?: string;
  size?: 'sm' | 'md';
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

const ToggleSetting = React.forwardRef<HTMLDivElement, ToggleSettingProps>(
  (
    {
      checked,
      onChange,
      title,
      description,
      size = 'md',
      disabled = false,
      className,
      'aria-label': ariaLabel,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={['flex items-center gap-8 justify-between', className].filter(Boolean).join(' ')}
        {...props}
      >
        <div className="flex flex-col gap-1">
          <div className="text-content-default text-sm font-medium">{title}</div>
          {description && <div className="text-content-subtle text-xs">{description}</div>}
        </div>
        <Toggle
          checked={checked}
          onChange={onChange}
          size={size}
          disabled={disabled}
          aria-label={ariaLabel || title}
          className="flex-shrink-0"
        />
      </div>
    );
  }
);

ToggleSetting.displayName = 'ToggleSetting';

export { ToggleSetting };
